<template>
  <container
    subHeaderTitle="세이프가드·금융사기방지<br /><b>유료 부가서비스 가입하기</b>"
    subHeaderText="서비스 가입 전 이용약관을 반드시 읽어보시고,<br />가입하시는 분의 정보를 정확히 입력하시기 바랍니다."
    subHeaderCaption="세이프가드&dot;금융사기방지는 은행, 카드사, 증권사, 보험, 대부업 등 금융기관 인증이력의<br />모니터링 및 알람을 제공하는 유료 부가서비스 입니다."
    subHeaderAlign="center"
  >
    <template v-slot="{showTerms}">
      <section class="form-area">
        <v-container class="py-0">
          <v-row justify="center">
            <v-col cols="12" md="6" sm="8">
              <v-form v-model="valid" ref="form" onsubmit="return false;">
                <p>휴대폰번호</p>
                <div class="d-flex">
                  <v-select
                    :items="items" 
                    item-text="text" 
                    item-value="value"
                    v-model="teleCoValue"
                    @change="handleTeleChange"
                    class="telecom_title"
                    solo
                  />
                  <v-text-field
                    ref="cellTelNo"
                    v-model="cellTelNo"
                    :rules="rules.cellTelNoRules"
                    label="'-'를 제외하고 입력"
                    mask="###########"
                    required
                    solo
                    maxlength="11"
                  />              
                </div>
                <div class="check-all">
                  <v-checkbox label="모든 약관 동의" v-if="teleCoCd != '2'" v-model="chk_all" @change="checkAll()" />
                  <v-checkbox v-else v-model="chk_all" @change="checkAll()" >
                    <template v-slot:label>
                      <span>모든 약관 동의</span> <span>(선택사항 포함)</span>
                    </template>
                  </v-checkbox>
                </div>
                <v-divider class="mt-2 mb-5" />
                <div class="check-item d-flex justify-space-between align-center">
                  <v-checkbox v-model="chk_a1" hide-details @change="checkBoxCheck()" :rules="rules.checkBoxRule">
                    <template v-slot:label>
                      <div v-if="teleCoCd == '1'">서비스 이용약관(필수)</div>
                      <div v-if="teleCoCd == '2'">서비스 이용약관(필수)</div>
                      <div v-if="isLGU">기본 서비스 이용약관(필수)</div>
                    </template>
                  </v-checkbox>
                  <div class="ml-auto">
                    <button type="button" @click.stop="showDialog1(showTerms)">
                      <v-icon>mdi-chevron-right</v-icon>
                    </button>
                  </div>
                </div>
                <div class="check-item d-flex justify-space-between align-center">
                  <v-checkbox v-model="chk_a2" hide-details @change="checkBoxCheck()" :rules="rules.checkBoxRule">
                    <template v-slot:label>
                      <div v-if="teleCoCd == '1'">개인정보 수집 및 이용동의(필수)</div>
                      <div v-if="teleCoCd == '2'">개인정보 수집 및 이용동의(필수)</div>
                      <div v-if="isLGU">서비스 이용약관(필수)</div>
                    </template>
                  </v-checkbox>
                  <div class="ml-auto">
                    <button type="button" @click.stop="showDialog2(showTerms)">
                      <v-icon>mdi-chevron-right</v-icon>
                    </button>
                  </div>
                </div>
                <div class="check-item d-flex justify-space-between align-center">
                  <v-checkbox v-model="chk_a3" hide-details @change="checkBoxCheck()" :rules="rules.checkBoxRule">
                    <template v-slot:label>
                      <div v-if="teleCoCd == '1'">개인정보 제3자 제공동의(필수)</div>
                      <div v-if="teleCoCd == '2'">
                        <template v-if="mvnoYn === 'N'">KT 개인정보 제3자 제공 동의(필수)</template>
                        <template v-else>KT MVNO 협정사업자 개인정보 제3자 제공동의(필수)</template>
                      </div>
                      <div v-if="isLGU">개인정보 수집 및 이용(필수)</div>
                    </template>
                  </v-checkbox>
                  <div class="ml-auto">
                    <button type="button" @click.stop="showDialog3(showTerms)">
                      <v-icon>mdi-chevron-right</v-icon>
                    </button>
                  </div>
                </div>
                <div class="check-item d-flex justify-space-between align-center">
                  <v-checkbox v-model="chk_a4" hide-details @change="checkBoxCheck()" :rules="teleCoCd === '2' ? [v => true] : rules.checkBoxRule">
                    <template v-slot:label>
                      <div v-if="teleCoCd == '1'">금융거래 알림(PUSH 동의)(필수)</div>
                      <div v-if="teleCoCd == '2'">금융거래 알림(PUSH 동의)(선택)</div>
                      <div v-if="isLGU">LGU+ 및 LGU+ MVNO 개인정보 제3자 제공동의(필수)</div>
                    </template>
                  </v-checkbox>
                  <div class="ml-auto">
                    <button type="button" @click.stop="showDialog4(showTerms)">
                      <v-icon>mdi-chevron-right</v-icon>
                    </button>
                  </div>
                </div>
                <div class="check-item d-flex justify-space-between align-center">
                  <v-checkbox v-model="chk_a5" hide-details @change="checkBoxCheck()" :rules="teleCoCd === '2' ? [v => true] : rules.checkBoxRule" >
                    <template v-slot:label>
                      <div v-if="teleCoCd == '1'">SKT 개인정보 제3자 제공동의(필수)</div>
                      <div v-if="teleCoCd == '2'">무료보험 가입 동의(선택)</div>
                      <!-- <div v-if="teleCoCd == '3'">금융거래 알림(PUSH 동의)(선택)</div> -->
                      <div v-if="isLGU" class="long_terms">핀브릿지 개인정보 제3자 제공(필수)</div>
                    </template>
                  </v-checkbox>
                  <div class="ml-auto">
                    <button type="button" @click.stop="showDialog5(showTerms)">
                      <v-icon>mdi-chevron-right</v-icon>
                    </button>
                  </div>
                </div>
                <div v-if="isLGU" class="check-item d-flex justify-space-between align-center">
                  <v-checkbox v-model="chk_a6" hide-details @change="checkBoxCheck()" :rules="!isLGU? [v => true] : rules.checkBoxRule">
                    <template v-slot:label>
                      <div v-if="isLGU">금융거래 알림(PUSH 동의)(필수)</div>
                    </template>
                  </v-checkbox>
                  <div class="ml-auto">
                    <button type="button" @click.stop="showDialog6(showTerms)">
                      <v-icon>mdi-chevron-right</v-icon>
                    </button>
                  </div>
                </div>
                <div class="recaptcha-area">
                  <vue-recaptcha ref="recaptcha" v-model="recaptchaVerify" @verify="onVerify" @expired="onExpired" :sitekey="$cfg.recaptchaSiteKey"></vue-recaptcha>
                  <div class="v-messages theme--light error--text mt-2">
                    <div class="v-messages__wrapper">
                      <div class="v-messages__message" v-if="!recaptchaVerifyCheck">로봇이 아닙니다를 체크해주세요</div>
                    </div>
                  </div>
                </div>
                <div>
                  <v-btn class="submit" rounded block large depressed color="primary" @click.stop="submit"
                  :data-ga-category="gaEvent.category.support.safeguard.contract.name" :data-ga-label="gaEvent.category.support.safeguard.contract.label1" :data-ga-action="gaEvent.actions.buttonClick"
                  >세이프가드&dot;금융사기방지 유료가입</v-btn>
                </div>
                <p class="mt-8 text-center" style="color: #ff0000;">본 서비스는 매월 2,200원(VAT 포함)이 통신요금에 합산 청구됩니다.</p>
              </v-form>
            </v-col>
          </v-row>
        </v-container>
      </section>
      <div class="mb-16">
        <v-container>
          <v-row justify="center">
            <v-col cols="12" md="6" sm="6">
              <div class="text-center term-btn">
                <v-btn v-if="teleCoCd === '2'" text @click="showTerms({termsCd: 'sgk020_footer_terms', prdtNo, teleCoCd})">서비스이용약관</v-btn>
                <v-btn v-else text @click="showTerms({termsCd: '002', prdtNo, teleCoCd})">서비스이용약관</v-btn>
                <span class="mx-1">|</span>
                <v-btn v-if="teleCoCd === '2'" text @click="showTerms({termsCd: 'sgk020_footer_per', prdtNo, teleCoCd})">개인정보처리방침</v-btn>
                <v-btn v-else text @click="showTerms({termsCd: '003', prdtNo, teleCoCd})">개인정보처리방침</v-btn>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </template>
  </container>
</template>

<style lang="scss" scoped>
@import "@/styles/cscenter";
</style>

<script>
import Container from "@/pages/container/index.vue";
import PassSafeguardContract from "@/views/csCenter/PassSafeguardContract.vue";
import {GaTracking} from "@/mixins/index.js";

export default {
  mixins: [PassSafeguardContract, GaTracking],
  name: "PassSafeguardContract",
  components: {
    Container
  },
  data() {
    return {
      items: [
        { text: 'SKT', value: '1' },
        { text: 'KT', value: '2' },
        { text: 'LG U+', value: '3' },
        { text: 'U+ 알뜰폰', value: '7' },
        { text: 'KT 알뜰폰', value: '8' }
      ],
      teleCoValue: "1"
    };
  },
  computed: {
    isLGU() {
      return this.teleCoCd == "3" || this.teleCoCd == "7";
    },
    mvnoYn() {
      return (this.teleCoValue == "7" || this.teleCoValue == "8") ? "Y" : "N";
    },
    prdtNo() {
      let prdtNo;
      switch (this.teleCoCd) {
        case "1":
          prdtNo = "A001";
          break;
        case "2":
        case "8":
          prdtNo = "A003";
          break;
        case "3":
        case "7":
          prdtNo = "A002";
          break;
        default:
          prdtNo = "A001";
          break;
      }
      return prdtNo;
    }
  },
  methods: {
    handleTeleChange(newCode) {
      this.chkClear();

      const codeMap = {
        '7': '3',
        '8': '2'
      };
      this.teleCoCd = codeMap[newCode] || newCode;
    },
    submit(e) {
        this.gaTracking(e);
      
      this.recaptchaVerifyCheck = this.recaptchaVerify;
      this.$refs.form.validate();
      if (!this.valid) {
        return false;
      }
      if (!this.recaptchaVerify) {
        return false;
      }

      if (this.isLGU) {
        // LGT 처리
        this.$router.push({
          name: "PassSafeguardIdVerify",
          params: {
            type: "contract",
            teleCoCd: this.teleCoCd,
            cellTelNo: this.cellTelNo,
            mvnoYn: this.mvnoYn
          }
        });
      } else if (this.teleCoCd == "2") {
        // KT 처리
        this.$router.push({
          name: "PassSafeGuardCert",
          params: {
            type: "contract",
            teleCoCd: this.teleCoCd,
            cellTelNo: this.cellTelNo,
            agreeYn: this.chk_a4,
            ansuranceAgreeYn: this.chk_a5,
            mvnoYn: this.mvnoYn
          }
        });
      } else {
        this.$router.push({
          name: "PassSafeGuardCert",
          params: {
            type: "contract",
            teleCoCd: this.teleCoCd,
            cellTelNo: this.cellTelNo
          }
        });
      }
    },

    showDialog1(showTerms) {
      let termsCd;
      switch (this.teleCoCd) {
        case "1":
          termsCd = "101";
          break;
        case "2":
          termsCd = "sgk010_join_terms"; // 201: 세이프가드 유료 서비스 이용약관 (필수)
          break;
        case "3":
        case "7":
          termsCd = "301";
          break;
        default:
          termsCd = "101";
      }
      showTerms({termsCd, prdtNo: this.prdtNo, teleCoCd: this.teleCoCd});
    },
    showDialog2(showTerms) {
      let termsCd;
      switch (this.teleCoCd) {
        case "1":
          termsCd = "102";
          break;
        case "2":
          termsCd = "sgk000_join_per"; // 202: 세이프가드 개인정보 수집 및 이용동의 (필수)
          break;
        case "3":
        case "7":
          termsCd = "302";
          break;
        default:
          termsCd = "102";
      }
      showTerms({termsCd, prdtNo: this.prdtNo, teleCoCd: this.teleCoCd});
    },
    showDialog3(showTerms) {
      let termsCd;
      switch (this.teleCoCd) {
        case "1":
          termsCd = "103";
          break;
        case "2":
          termsCd = this.mvnoYn === "N" ? "sgk000_join_kt3" : "sgk200_join_kt3"; // 203: KT 개인정보 제3자 제공동의(필수)
          break;
        case "3":
        case "7":
          termsCd = "303";
          break;
        default:
          termsCd = "103";
      }
      showTerms({termsCd, prdtNo: this.prdtNo, teleCoCd: this.teleCoCd, mvnoYn: this.mvnoYn});
    },
    showDialog4(showTerms) {
      let termsCd;
      switch (this.teleCoCd) {
        case "1":
          termsCd = "104";
          break;
        case "2":
          termsCd = "sgk001_join_push"; // 204: 금융거래 알림 PUSH 동의 (선택)
          break;
        case "3":
        case "7":
          termsCd = "304";
          break;
        default:
          termsCd = "104";
      }
      showTerms({termsCd, prdtNo: this.prdtNo, teleCoCd: this.teleCoCd});
    },
    showDialog5(showTerms) {
      let termsCd;
      switch (this.teleCoCd) {
        case "1":
          termsCd = "105";                // 105: SKT 개인정보 제3자 제공동의(필수)
          break;
        case "2":
          termsCd = "sgk011_insur_terms"; // 205: 무료보험 가입동의(선택)
          break;
        case "3":
        case "7":
          termsCd = "306";
          break;
        default:
          termsCd = "sgk011_insur_terms"; // 205: 무료보험 가입동의(선택)
      }
      showTerms({termsCd, prdtNo: this.prdtNo, teleCoCd: this.teleCoCd});
    },
    showDialog6(showTerms) {
      let termsCd;
      switch (this.teleCoCd) {
        
        case "3":
        case "7":
          termsCd = "305";
          break;
        default:
          termsCd = "305";
      }
      showTerms({termsCd, prdtNo: this.prdtNo, teleCoCd: this.teleCoCd});
    },
  }
};
</script>
<style scoped>
@media (max-width: 411px) {
  .telecom_title {
    font-size: 12px;
  }
}

@media (max-width: 325px) {
  .long_terms {
    font-size: 13px;
  }
}
</style>
